/* eslint-disable */
import { ContentType, HttpClient, RequestParams } from "./http-client";

export class AdminLibrary<SecurityDataType = unknown> extends HttpClient<SecurityDataType> {
  books = (params: RequestParams = {}) =>
    this.request<any, any>({ path: `/AdminLibrary/Books`, method: "GET", secure: true, ...params });
  ingest = (data: { book: string; subject: number; chapter: string; text: string }, params: RequestParams = {}) =>
    this.request<any, any>({ path: `/AdminLibrary/Ingest`, method: "POST", body: data, secure: true, type: ContentType.Json, ...params });
  rename = (id: string, data: { title: string }, params: RequestParams = {}) =>
    this.request<any, any>({ path: `/AdminLibrary/${id}`, method: "PUT", body: data, secure: true, type: ContentType.Json, ...params });
  remove = (id: string, params: RequestParams = {}) =>
    this.request<any, any>({ path: `/AdminLibrary/${id}`, method: "DELETE", secure: true, ...params });
}
